import { Grid } from "@mui/material";
import Portada_SobreMi from "./Componentes/Portada_SobreMi";
import { Helmet } from "react-helmet";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import Quienes_Nuestro_Nosotros from "./Componentes/Quienes_Nuestro_Nosotros";
import MisionVision_Home from "./Componentes/MisionVision_Home";
import Nuestro_Nosotros from "./Componentes/Nuestro_Nosotros";

const Seccion_Sobre_Mi = () => {
    const { sCell, sTab } = useResponsive();

    return (
        <>
            <Helmet>
                <title>Espacio Compacto en Cali | Expertos en Mantenimiento Locativo y SST</title>
                <meta
                    name="description"
                    content="Espacio Compacto en Cali: especialistas en mantenimiento locativo y adecuaciones técnicas con cumplimiento SST para empresas y copropiedades."
                />
                <meta
                    name="keywords"
                    content="mantenimiento locativo Cali, adecuaciones locativas Cali, SST Colombia, mantenimiento locativo empresas, infraestructura locativa, Espacio Compacto"
                />
                <link rel="canonical" href="https://espaciocompacto.com/nosotros/" />
                <meta property="og:title" content="Espacio Compacto en Cali | Mantenimiento Locativo y SST" />
                <meta
                    property="og:description"
                    content="Conoce a Espacio Compacto, especialistas en adecuaciones locativas y mantenimiento técnico con cumplimiento SST en Cali."
                />
                <meta property="og:url" content="https://espaciocompacto.com/nosotros/" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                {/* 🔹 Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Espacio Compacto en Cali | Mantenimiento Locativo" />
                <meta
                    name="twitter:description"
                    content="Expertos en mantenimiento locativo y adecuaciones técnicas en Cali con enfoque en SST."
                />
                <meta name="twitter:image" content="https://espaciocompacto.com/Espaci_Compacto.png" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        name: "Espacio Compacto",
                        url: "https://espaciocompacto.com",
                        logo: "https://espaciocompacto.com/Espaci_Compacto.png",
                        description:
                            "Empresa especializada en mantenimiento locativo y adecuaciones técnicas con enfoque en SST en Cali, Colombia.",
                        address: {
                            "@type": "PostalAddress",
                            addressLocality: "Cali",
                            addressRegion: "Valle del Cauca",
                            addressCountry: "CO"
                        },
                        areaServed: {
                            "@type": "Place",
                            name: "Cali, Colombia"
                        }
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{ xs: 12, sm: 12, md: 12 }}
            >
                <Grid container size={{ xs: 12, sm: 12, md: 12 }}  sx={{pt: 12}}>
                    <Portada_SobreMi />
                </Grid>

                <Grid container size={{ xs: 12, sm: 12, md: 12 }} >
                    <Quienes_Nuestro_Nosotros />
                </Grid>

                <Grid container size={{ xs: 12, sm: 12, md: 12 }} sx={{pt:sCell?8:16}}>
                    <MisionVision_Home />
                </Grid>

                <Grid container size={{ xs: 12, sm: 12, md: 12 }} sx={{pt:sCell?8:16}}>
                    <Nuestro_Nosotros />
                </Grid>
            </Grid>
        </>
    );
};
export default Seccion_Sobre_Mi;
